<template>
    <div>
        <base-page-header :breadcrumb="breadcrumb" :title="infoRoute.name">
        </base-page-header>

        <v-row>
            <v-col cols="12" class="text-right pt-0 mb-3">
                <span @click="handlerOnClick(infoRoute.prev)" v-show="infoRoute.currentLen != 1" class="cursor-pointer">
                    <img src="/images/_SVGs/environmental/seta-direita-small.svg" width="22" height="22" alt="Prev" class="rotation-180" onload="SVGInject(this)" />
                </span>

                <span class="qtd-route">
                    <span class="current">{{infoRoute.currentLen}}</span>/{{routes.length}}
                </span>

                <span @click="handlerOnClick(infoRoute.next)" v-show="infoRoute.currentLen < routes.length" class="cursor-pointer">
                    <img src="/images/_SVGs/environmental/seta-direita-small.svg" width="22" height="22" alt="Next" onload="SVGInject(this)" />
                </span>
            </v-col>
        </v-row>

        <v-row class="bg-white" style="border-radius: 7px" v-if="infoRoute.statusId == 2">
            <v-col cols="12" sm="12">
                <span>
                    {{transporterInfo.nif}} - {{transporterInfo.name}}
                </span>
                <span style="position: relative;display: inline-block;float: right;">
                    <base-button
                        class="d-block btn-action mb-2"
                        text
                        height="34"
                        width="100%"
                        @click="editRouteModal"
                    >
                        <div class="d-flex min-width-100" >

                            <span class="primary--text font-weight-bold btn-edit-route">
                                <img src="/images/_SVGs/environmental/pendente.svg" alt="Pendente" onload="SVGInject(this)" class="mr-1" width="20" height="20"/>
                                {{$t('environmental-management.route-management.edit.edit-date-span')}}
                            </span>
                        </div>
                    </base-button>
                </span>
            </v-col>
            <v-col cols="12" sm="6" class="pt-0">
                <span class="subTitleCurso">
                    {{ transporterInfo.plateNumber }} | {{ transporterInfo.transportationStartDate | formatOnlyDate }} | {{$t('environmental-management.route-management.edit.ongoing')}} <!--| {{ infoRoute.kms}} Km-->
                </span>
            </v-col>

            <v-col cols="12" sm="6" class="text-md-right text-center pt-0">
                <v-row>
                    <v-col cols="3" class="d-flex align-center justify-end" style="justify-content: flex-end; ">
                        <img src="/images/_SVGs/environmental/oficinas.svg" width="22" height="22" onload="SVGInject(this)" />
                        {{doneEgars}}/{{infoRoute.totalEgars}}
                    </v-col>
                    <v-col cols="5" class="d-flex align-center justify-end">
                        <v-progress-linear :value="calcPercentual(infoRoute.totalEgars,doneEgars)"></v-progress-linear>
                    </v-col>
                    <v-col cols="4" class="d-flex align-center justify-center">
                        <a class="link-router" @click="getListEntities()">
                            {{$t('environmental-management.route-management.edit.entities-route-list-span')}}
                        </a>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12" class="data-p">
                <v-data-table
                    :headers="headersActive"
                    :items="egars"
                    :single-expand="singleExpand"
                    :expanded.sync="expanded"
                    :page="pageEg"
                    :pageCount="numberOfPagesEg"
                    :options.sync="optionsEg"
                    :server-items-length="totalItemsEg"
                    item-key="egarId"
                    show-expand
                    class="elevation-1"
                >
                    <template v-slot:item.status="{ index, item }">
                        <span v-html="statusHandler(item, index)"></span>
                    </template>
                    <template v-slot:item.createDate="{ item }">
                        {{item.createDate | formatOnlyDate}}
                    </template>
                    <template v-slot:item.producer="{ item }">
                        <p class="title-table">{{item.producer.nif}} - {{item.producer.name}}</p>
                        <p class="subTitle-table">{{item.producer.apaCode}} - {{item.producer.name}}</p>
                    </template>

                    <template v-slot:item.morada="{ item }">
                        {{item.producer.address}} {{item.producer.locality}}
                    </template>
                    <template v-slot:item.transportedResidue="{ item }">
                        <p class="title-table">{{item.transportedResidue? item.transportedResidue[0].designation : ''}}</p>
                        <p class="subTitle-table">{{item.transportedResidue? item.transportedResidue[0].groupCode : ''}} - {{item.transportedResidue? item.transportedResidue[0].lerDescription : ''}}</p>
                    </template>
                    <template v-slot:item.qtd="{ item }">
                        {{item.transportedResidue? item.transportedResidue[0].quantity + ' Kg' : '-'}}
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" v-if="!item.routeEgarReason">
                            {{$t('environmental-management.route-management.edit.no-info')}}
                        </td>
                        <td :colspan="headers.length" v-else style="color:var(--v-error-base); background-color: var(--v-error-lighten5)">
                            <b>{{$t('environmental-management.route-management.edit.route-reason')}}</b> {{item.routeEgarReason}}
                        </td>
                    </template>
                </v-data-table>
            </v-col>
            <v-col cols="12" sm="2">
                <div class="back ml-4" @click="$router.push({name: 'environmentalManagementRouteManagement'})">
                    <div><img src="/images/_SVGs/back.svg" :alt="$t('back')" onload="SVGInject(this)" /></div>
                    <div>{{$t('back')}}</div>
                </div>
            </v-col>
        </v-row>

        <v-row class="bg-white" style="border-radius: 7px" v-else>
            <v-col cols="12" sm="6">
                <div class="d-flex align-center">
                    <span class="pendent d-flex align-center mr-1" v-html="getStatus(+infoRoute.statusId)"></span> <!--| {{infoRoute.kms}} Km-->
                </div>
            </v-col>
            <v-col cols="12" sm="6" class="text-md-right text-right">
                <v-row>
                    <v-col cols="3" class="d-flex align-center justify-end" style="justify-content: flex-end; ">
                        <img src="/images/_SVGs/environmental/oficinas.svg" width="22" height="22" onload="SVGInject(this)" />
                        {{infoRoute.totalEgars}}x
                    </v-col>
                    <v-col cols="5" class="d-flex align-center justify-end">
                        <v-progress-linear value="0"></v-progress-linear>
                    </v-col>
                    <v-col cols="4" class="d-flex align-center justify-center">
                        <a class="link-router" @click="getListEntities()">
                           {{$t('environmental-management.route-management.edit.entities-route-list-span')}}
                        </a>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" class="data-p">
                <v-data-table
                    :headers="headers"
                    :items="egars"
                    :page="pageEg"
                    :pageCount="numberOfPagesEg"
                    :options.sync="optionsEg"
                    :server-items-length="totalItemsEg"
                >
                    <!-- :hide-default-footer="true" -->
                    <template v-slot:item.createDate="{ item }">
                        {{item.createDate | formatOnlyDate}}
                    </template>
                    <template v-slot:item.producer="{ item }">
                        <p class="title-table">{{item.producer.nif}} - {{item.producer.name}}</p>
                        <p class="subTitle-table">{{item.producer.apaCode}} - {{item.producer.name}}</p>
                    </template>

                    <template v-slot:item.morada="{ item }">
                        {{item.producer.address}} {{item.producer.locality}}
                    </template>
                    <template v-slot:item.transportedResidue="{ item }">
                        <p class="title-table">{{item.transportedResidue? item.transportedResidue[0].designation : ''}}</p>
                        <p class="subTitle-table">{{item.transportedResidue? item.transportedResidue[0].groupCode : ''}} - {{item.transportedResidue? item.transportedResidue[0].lerDescription : ''}}</p>
                    </template>
                    <template v-slot:item.qtd="{ item }">
                        {{item.transportedResidue? item.transportedResidue[0].quantity + ' Kg' : '-'}}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <span @click="removeRoute(item.egarId)" class="button-delete">
                            <img src="/images/_SVGs/environmental/fechar.svg" alt="add item" onload="SVGInject(this)" width="30" />
                        </span>
                    </template>
                </v-data-table>
            </v-col>
            <v-col cols="12" class="p-0 mb-4" >
                <div class="float-md-right mr-md-4 btn-add" @click="addEgars()" v-show="egars.length < infoRoute.maxEgarRequest">
                    <img src="/images/_SVGs/bo/adicionar.svg" alt="add item" onload="SVGInject(this)" class="circle" width="30" />
                </div>
            </v-col>
        </v-row>

        <v-row class="mt-8" v-if="infoRoute.statusId == 1">
            <v-col cols="3" sm="2">
                <div class="back ml-4" @click="$router.push({name: 'environmentalManagementRouteManagement'})">
                    <div><img src="/images/_SVGs/back.svg" alt="voltar" onload="SVGInject(this)" /></div>
                    <div>{{$t('back')}}</div>
                </div>
            </v-col>
            <v-col cols="8" class="p-0 mb-4">
                <div class="mx-auto text-center">
                    <v-btn v-if="loaded" rounded class="btn-primary-custom" @click="lauchPreFilled">{{$t('environmental-management.route-management.edit.launch-route')}}</v-btn>
                </div>
            </v-col>
        </v-row>

        <base-modal :persistent="true" v-model="listRoutesEntities.show" :title="$t('environmental-management.route-management.edit.modal-routes-entities.title')" modalAlign="align__flex--right" modal-width="560px">
            <template v-slot:modal-body>
                <v-data-table
                    :headers="listRoutesEntities.headers"
                    :items="listRoutesEntities.items"
                    :hide-default-footer="true"
                >
                </v-data-table>
            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn class="primary-button" text @click="listRoutesEntities.show = false">
                        {{$t('ok')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="listEgars.show" :title="$t('environmental-management.route-management.edit.modal-list-egars.title')" modalAlign="align__flex--right" modal-width="700px">
            <template v-slot:modal-body>
                <v-data-table
                    v-model="listEgars.selected"
                    :headers="listEgars.headers"
                    :items="egarsNotAssociate"
                    :page="page"
                    :pageCount="numberOfPages"
                    :options.sync="options"
                    :server-items-length="totalRecords"
                    :footer-props="{
                        showFirstLastPage: true,
                        'items-per-page-options': [10, 20, 50]
                    }"
                    item-key="egarId"
                    show-select
                >
                    <template v-slot:item.createDate="{ item }">
                        {{item.createDate | formatOnlyDate}}
                    </template>
                    <template v-slot:item.producer="{ item }">
                        <p class="title-table">{{item.producer.nif}} - {{item.producer.name}}</p>
                        <p class="subTitle-table">{{item.producer.apaCode}} - {{item.producer.name}}</p>
                    </template>

                    <template v-slot:item.morada="{ item }">
                        {{item.producer.address}} {{item.producer.locality}}
                    </template>
                    <template v-slot:item.transportedResidue="{ item }">
                        <p class="title-table">{{item.transportedResidue? item.transportedResidue[0].designation : ''}}</p>
                        <p class="subTitle-table">{{item.transportedResidue? item.transportedResidue[0].groupCode : ''}} - {{item.transportedResidue? item.transportedResidue[0].lerDescription : ''}}</p>
                    </template>
                    <template v-slot:item.qtd="{ item }">
                        {{item.transportedResidue? item.transportedResidue[0].quantity + ' Kg' : '-'}}
                    </template>
                </v-data-table>


            </template>

            <template v-slot:modal-actions class="align__flex--right">
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="cancelAddEgarRouter">
                        {{$t('cancel')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="addEgarRouter" :disabled="listEgars.selected.length == 0">
                        {{$t('add')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalDelete.show" :title="$t('environmental-management.route-management.edit.modal-delete.title')" modal-width="560px" >
            <template v-slot:modal-close>
                <div @click="modalDelete.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{modalDelete.msg}}
            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn class="danger-button" text @click="notDelete()">
                        {{$t('no')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="confirmDelete()">
                        {{$t('yes')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalAlert.show" :title="$t('heads-up')" modal-width="560px" >
            <template v-slot:modal-close>
                <div @click="handlerOkAlertModal()">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{modalAlert.msg}}
            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn class="primary-button" text @click="handlerOkAlertModal()">
                        {{$t('ok')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalShow.show" :title="$t('environmental-management.route-management.edit.modal-transporter.title')" modalAlign="align__flex--center" modal-width="400px">
            <template v-slot:modal-body>
                <v-form v-model="modalShow.form.isValid">
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                :items="modalShow.form.transporters.length > 0? modalShow.form.transporters.map(el => ({text: el.nif + ' - ' + el.fullName,value: el})) : []"
                                v-model="modalShow.form.transporter"
                                :rules="formRules.defaultRules"
                                filled
                                hide-details="auto"
                                :label="$t('environmental-management.route-management.intervenient-type-req')"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field
                                :label="$t('environmental-management.route-management.plate-nbr')"
                                v-model="modalShow.form.transporter.plateNumber"
                                filled
                                :rules="formRules.defaultRules"
                                readonly
                                hide-details="auto"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-menu
                                ref="menuDate"
                                v-model="menuDate"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="modalShow.form.data"
                                        :rules="formRules.defaultRules"
                                        :label="$t('environmental-management.route-management.date-req')"
                                        persistent-hint
                                        v-bind="attrs"
                                        filled
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="modalShow.form.data"
                                    no-title
                                    @input="menuDate = false"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="menuDate = false"
                                    >
                                        {{$t('cancel')}}
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menuDate.save(modalShow.form.data)"
                                    >
                                        {{$t('ok')}}
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>

                        </v-col>
                    </v-row>
                </v-form>
            </template>

            <template v-slot:modal-actions class="align__flex--center">
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="cancelRoute">
                        {{$t('cancel')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="preFilledCreate" :disabled="!modalShow.form.isValid">
                        {{$t('confirm')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalEdit.show" :title="$t('environmental-management.route-management.edit.modal-edit.title')" modalAlign="align__flex--center" modal-width="400px">
            <template v-slot:modal-body>
                <v-form v-model="modalEdit.form.isValid">
                    <v-row>
                        <v-col cols="12">
                            <v-menu
                                ref="menuDate"
                                v-model="menuDate"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="modalEdit.form.data"
                                        :rules="formRules.defaultRules"
                                        :label="$t('environmental-management.route-management.date-req')"
                                        persistent-hint
                                        v-bind="attrs"
                                        filled
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="modalEdit.form.data"
                                    no-title
                                    @input="menuDate = false"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="menuDate = false"
                                    >
                                        {{$t('cancel')}}
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menuDate.save(modalEdit.form.data)"
                                    >
                                        {{$t('ok')}}
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>

                        </v-col>
                    </v-row>
                </v-form>
            </template>

            <template v-slot:modal-actions class="align__flex--center">
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="cancelEdit">
                        {{$t('cancel')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="editRoute()" :disabled="!modalEdit.form.isValid">
                        {{$t('confirm')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
    import { GetRouterPreDefined, GetMainRouteEntities, PostAssociateEgars, GetLauchPreFilled, PostLauchRouter, DeleteAssociateEgar, GetTransporterToRoute, PutRouter } from '@services/b2b/environmental-management/RouterService'
    import { GetEgars } from '@services/b2b/environmental-management/EgarService'
    import { required } from '@src/utils/validations.js';
    import dayjs from 'dayjs';
    import BaseModal from "@components/shared/widgets/BaseModal.vue";
    import BaseButton from "@components/shared/widgets/BaseButton.vue";
    import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";


    export default {
        components: {BasePageHeader, BaseButton, BaseModal},
        data(){
            return{
                loaded: false,
                breadcrumb: [
                    {
                        title: this.$t('environmental-management.title'),
                        routerLinkName: 'environmentalManagement'
                    },
                    {
                        title: this.$t('environmental-management.route-management.title'),
                        routerLinkName: 'environmentalManagementRouteManagement'
                    },
                    {
                        title: ''
                    }
                ],
                formRules: {
                    defaultRules: [required]
                },
                modalDelete: {
                    show: false,
                    msg: '',
                    idEgar: 0
                },
                modalAlert: {
                    show: false,
                    noRefresh: false,
                    msg: '',
                },
                routeId: 0,
                routes:[],
                filters: [],
                infoRoute: {
                    name: '',
                    kms: 0,
                    statusId: 1,
                    totalEgars: 0,
                    currentLen:0,
                    doneEgars: 0,
                    next: 0,
                    prev: 0,
                    maxEgarRequest: 0,
                    siLiAmbMainRouteID: 0
                },
                headers: [
                    {
                        text: this.$t('environmental-management.route-management.list-egars-headers.request-date'),
                        align: 'start',
                        value: 'createDate',
                        sortable: false
                    },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.producer'), value: 'producer', sortable: false },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.adress'), value: 'morada', sortable: false },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.residue'), value: 'transportedResidue', sortable: false },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.qtd'), value: 'qtd', sortable: false },
                    { text: '', value: 'action', sortable: false },

                ],
                headersActive:[
                    {
                        text: '#',
                        value: 'status',
                        sortable: false
                    },
                    {
                        text: this.$t('environmental-management.route-management.list-egars-headers.request-date'),
                        align: 'start',
                        value: 'createDate',
                        sortable: false
                    },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.producer'), value: 'producer', sortable: false },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.adress'), value: 'morada', sortable: false },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.residue'), value: 'transportedResidue', sortable: false },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.qtd'), value: 'qtd', sortable: false },
                    { text: '', value: 'data-table-expand', sortable: false },

                ],
                egars:[],
                listEgars:{
                    show: false,
                    selected: [],
                    headers: [
                        {
                            text: this.$t('environmental-management.route-management.list-egars-headers.request-date'),
                            align: 'start',
                            value: 'createDate',
                        },
                        { text: this.$t('environmental-management.route-management.list-egars-headers.producer'), value: 'producer' },
                        { text: this.$t('environmental-management.route-management.list-egars-headers.adress'), value: 'morada' },
                        { text: this.$t('environmental-management.route-management.list-egars-headers.residue'), value: 'transportedResidue' },
                        { text: this.$t('environmental-management.route-management.list-egars-headers.qtd'), value: 'qtd' },
                        { text: '', value: 'data-table-select' },

                    ],
                },
                page: 1,
                numberOfPages:0,
                options: {
                    page: 1,
                    itemsPerPage: 10
                },
                totalRecords: 0,
                egarsNotAssociate: [],
                menuDate: false,
                modalShow: {
                    show: false,
                    form: {
                        isValid: false,
                        transporters: [],
                        data: null,
                        transporter: {
                            fullName: null,
                            nif: null,
                            plateNumber: null
                        }
                    }
                },
                modalEdit: {
                    show: false,
                    form: {
                        isValid: false,
                        date: null,
                    }
                },
                singleExpand: false,
                expanded: [],
                headersTrue: [

                    { text: '#', value: 'status' },
                    {
                        text: this.$t('environmental-management.route-management.list-egars-headers.request-date'),
                        align: 'start',
                        value: 'date',
                    },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.producer'), value: 'produtor' },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.adress'), value: 'morada' },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.residue'), value: 'ler' },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.qtd'), value: 'qtd' },
                    { text: '', value: 'data-table-expand' },
                ],
                listRoutesEntities:{
                    show: false,
                    headers: [
                        {
                            text: this.$t('environmental-management.route-management.list-egars-headers.nif'),
                            align: 'start',
                            value: 'nif',
                        },
                        { text: this.$t('environmental-management.route-management.list-egars-headers.producer'), value: 'comercialName' },
                        { text: this.$t('environmental-management.route-management.list-egars-headers.contact-name'), value: 'contactName' },
                        { text: this.$t('environmental-management.route-management.list-egars-headers.telephone'), value: 'telephone' },
                    ],
                    items: [],
                },
                transporterInfo: {
                    name: '',
                    nif: '',
                    plateNumber: '',
                    transportationStartDate: ''

                },
                pageEg: 1,
                numberOfPagesEg: 1,
                optionsEg: {
                    page: 1,
                    itemsPerPage: 10
                },
                totalItemsEg: 1,
            }
        },
        watch:{
            routes: {
                handler: function(newValue, oldValue) {
                    if(newValue.length > 0) {
                        const indexRouter = newValue.findIndex(el => el.routeId == this.routeId)
                        const filterRouter = newValue.filter(el => el.routeId == this.routeId)[0];
                        //console.log('newValue', filterRouter)


                        this.breadcrumb[2].title = filterRouter.name
                        this.infoRoute.name = filterRouter.name
                        this.infoRoute.currentLen = newValue.findIndex(el => el.routeId == this.routeId) + 1

                        this.infoRoute.next = newValue[indexRouter + 1]?.routeId
                        this.infoRoute.prev = newValue[indexRouter - 1]?.routeId
                        this.infoRoute.statusId = filterRouter.statusId
                        this.infoRoute.totalEgars = filterRouter.totalEgars
                        //this.infoRoute.doneEgars = filterRouter.doneEgars
                        this.infoRoute.maxEgarRequest = filterRouter.maxEgarRequest
                        this.infoRoute.siLiAmbMainRouteID = filterRouter.siLiAmbMainRouteID

                        if(filterRouter.statusId == 2){
                            this.getTransporter()
                        }
                    }
                },
                deep: true,
                immediate: false,
            },
            "options.page": {
                handler() {
                this.$emit('alterTable', this.options);
                },
            },
            "options.itemsPerPage": {
                handler() {
                this.$emit('alterTable', this.options);
                },
            },
            "optionsEg.page": {
                handler() {
                    this.alterEgTable(this.optionsEg);
                },
            },
            "optionsEg.itemsPerPage": {
                handler() {
                    this.alterEgTable(this.optionsEg);
                },
            },
        },
         computed:{
            doneEgars() {
                if(!this.routes || this.routes.length == 0) return 0;
                let route = this.routes.find(o => o.routeId == this.routeId);
                return route.doneEgars;
                const filtered = this.egars.filter(item => item.routeEgarStatusID && (item.routeEgarStatusID == 1 || item.routeEgarStatusID == 2) && item.status !== 1 && item.status !== 2);
                return filtered ? filtered.length : 0;
            }
        },
        methods:{
            cancelEdit(){
                this.modalEdit.show = false;
            },
            editRouteModal(){
                this.modalEdit.show = true;
            },
            editRoute(){
                this.modalEdit.show = false

                let body = {
                    LaunchDate: dayjs(this.modalEdit.form.data).format("YYYY-MM-DD") + 'T00:00:00.0000'
                }

                this.$store.commit('loadings/setStateLoadingTemplate', true);
                return PutRouter(this.routeId, body)
                .then(response => {
                    this.modalAlert.msg = this.$t('environmental-management.route-management.edit.modal-alert.msg1');
                    this.modalAlert.show = true;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.modalAlert.msg = this.$t('environmental-management.route-management.edit.modal-alert.msg2');
                    this.modalAlert.show = true;
                    throw new Error('error to get PutRouter values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            calcPercentual(total, done){
                if(done > 0){
                    let calc = (done * 100);
                    return calc / total;
                }
                return 0
            },
            statusHandler(item, index){
                if(item.routeEgarStatusID == 2){
                    return '<img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" class="mr-1 danger" width="20" height="20"/>'
                }else if(item.routeEgarStatusID == 1){
                    return '<img src="/images/_SVGs/environmental/check.svg" onload="SVGInject(this)" class="mr-1 successIcon" width="20" height="20"/>'
                }else{
                    return index + 1;
                }
            },
            lauchPreFilled(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                GetLauchPreFilled()
                .then(response => {

                    this.modalShow.form.transporters = response.data.result
                    this.modalShow.show = true

                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error to get getPreRoutes values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            cancelRoute(){
                this.modalShow.form.transporter = []
                this.modalShow.form.data= null

                this.modalShow.show = false
            },
            preFilledCreate(){
                this.modalShow.show = false

                let body = {
                    transporterId: this.modalShow.form.transporter.id,
                    launchDate: dayjs(this.modalShow.form.data).format("YYYY-MM-DD") + 'T00:00:00.0000'
                }

                this.$store.commit('loadings/setStateLoadingTemplate', true);
                return PostLauchRouter(this.routeId, body)
                    .then(response => {
                        this.modalAlert.msg = this.$t('environmental-management.route-management.edit.modal-alert.msg3');
                        this.modalAlert.show = true;
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        this.modalAlert.msg = this.$t('environmental-management.route-management.edit.modal-alert.msg4');
                        this.modalAlert.show = true;
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            handlerOkAlertModal(){
                if(this.modalAlert.noRefresh){
                    this.modalAlert.noRefresh = false;
                    this.modalAlert.show = false
                }else{
                    this.$router.go();
                }
            },
            cancelAddEgarRouter(){
                this.listEgars.selected = []
                this.listEgars.show = false
            },
            addEgarRouter(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                if((this.egars.length + this.listEgars.selected.length) > this.infoRoute.maxEgarRequest){

                    this.modalAlert.msg = `${this.$t('environmental-management.route-management.edit.modal-alert.msg5')} ${this.infoRoute.maxEgarRequest}!`
                    this.modalAlert.noRefresh = true

                    this.modalAlert.show = true

                    return
                }

                let body = {
                    egarIds: this.listEgars.selected.map(el => el.egarId)
                }

                this.egars.map(el => {
                    body.egarIds.push(el.egarId)
                })


                this.listEgars.show = false

                return PostAssociateEgars(this.routeId, body)
                    .then(response => {
                        this.modalAlert.msg = this.$t('environmental-management.route-management.edit.modal-alert.msg6')
                        this.modalAlert.show = true
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        this.modalAlert.msg = this.$t('environmental-management.route-management.edit.modal-alert.msg7')
                        this.modalAlert.show = true
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            removeRoute(id){
                this.modalDelete.idEgar = id
                this.modalDelete.msg = this.$t('environmental-management.route-management.edit.modal-delete.msg1')
                this.modalDelete.show = true
            },
            notDelete(){
                this.modalDelete.idEgar = 0
                this.modalDelete.msg = ''
                this.modalDelete.show = false
            },
            confirmDelete(){
                this.$store.commit('loadings/setStateLoadingTemplate', false);

                this.modalDelete.show = false
                return DeleteAssociateEgar(this.routeId, this.modalDelete.idEgar)
                    .then(response => {
                        this.modalAlert.msg = this.$t('environmental-management.route-management.edit.modal-alert.msg8')
                        this.modalAlert.show = true
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        this.modalAlert.msg = this.$t('environmental-management.route-management.edit.modal-alert.msg9')
                        this.modalAlert.show = true
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })

            },
            getStatus(item){
                switch (item) {
                    case 1:
                        return '<img src="/images/_SVGs/environmental/pendente.svg" alt="Pendente" onload="SVGInject(this)" class="mr-1" width="20" height="20"/> Pendente'
                    case 2:
                        return '<img src="/images/_SVGs/environmental/road.svg" alt="Em Rota" onload="SVGInject(this)" class="mr-1" width="20" height="20"/> Em Rota'
                    default:
                        return '-'
                }
            },
            getPreRoutes(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                GetRouterPreDefined()
                .then(response => {
                    this.routes = response.data.result;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error to get getPreRoutes values', error);
                })
                .finally(() => {
                    this.loaded = true;
                })
            },
            getAllEGAR(){
                // this.filters = [];
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                    Object.assign(this.filters, {
                        pageSize: this.filters.pageSize ? this.filters.pageSize : 10,
                        hasRoutes: true,
                        routeId: this.routeId
                    }
                )
                return GetEgars(this.filters)
                    .then(response => {
                        this.egars = response.data.result ? response.data.result : [];
                        this.totalItemsEg = response.data.totalRecords ? response.data.totalRecords : 0;
                        this.pageEg = response.data.currentPage ? response.data.currentPage : 1;
                        this.numberOfPagesEg = response.data.totalPages ? response.data.totalPages : 1;
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.getPreRoutes();
                        this.filters= [];
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            addEgars(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                    Object.assign(this.filters, {
                        statusIds: [2],
                        hasRoutes: false,
                    }
                )
                return GetEgars(this.filters)
                    .then(response => {
                        this.totalRecords = response.data.totalRecords
                        this.egarsNotAssociate = response.data.result
                        this.listEgars.show = true
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            getListEntities(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                // console.log('this.infoRoute.siLiAmbMainRouteID :>> ', this.infoRoute.siLiAmbMainRouteID);
                if(this.listRoutesEntities.items.length > 0){
                    this.listRoutesEntities.show = true
                    this.$store.commit('loadings/setStateLoadingTemplate', false);

                }else{
                    GetMainRouteEntities(this.routeId)
                    .then(response => {
                        this.listRoutesEntities.items = response.data.result
                        this.listRoutesEntities.show = true
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get getPreRoutes values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
                }
            },
            getTransporter(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                GetTransporterToRoute(this.routeId)
                    .then(response => {

                        this.transporterInfo.name = response.data.result.name
                        this.transporterInfo.nif = response.data.result.nif
                        this.transporterInfo.plateNumber = response.data.result.plateNumber
                        this.transporterInfo.transportationStartDate = response.data.result.transportationStartDate
                    })
                    .catch(error => {
                        throw new Error('error to get GetTransporterToRoute values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            handlerOnClick(id){
                this.$router.push({ name: 'environmentalManagementRouteManagementEdit', params: { id: id}})
                this.$router.go();
            },
            alterEgTable(filters) {
                this.optionsEg.itemsPerPage = filters.itemsPerPage;
                // let sort = ''

                // if(filters.sortDesc[0] == true){
                //     sort = 'DESC';
                // }else if(filters.sortDesc[0] == false){
                //     sort = 'ASC';
                // }

                Object.assign(this.filters, {
                        pageSize: filters.itemsPerPage,
                        currentPage: filters.page,
                        // orderField: filters.sortBy[0] ? filters.sortBy[0] : '',
                        // orderBy: sort
                    }
                )
                this.getAllEGAR()
            },
        },
        created(){
            this.routeId = this.$route.params.id
            this.getAllEGAR();
        }
    }
</script>

<style lang="scss" scoped>

@import '@sass/_variables.scss';
.base-page-header-container{
    margin-bottom: 0;
}
.link-router{
    font-size: 12px;
    color: var(--v-primary-base);
    &:hover{
        font-weight: 600;
    }
}
.btn-primary-custom{
    text-transform: capitalize;
}
.btn-add{
    cursor: pointer;
}

.data-p{
    ::v-deep table{
        thead {

            th{
                font-size: 13px !important;
                border: 1px solid rgb(224 224 224);
                height: 30px !important;
                background: $grey-light;
                color:rgb(113 113 113 / 60%) !important;
            }
        }
        tbody{
            td{
                border: 1px solid rgb(224 224 224);
                font-size: 13px !important;
                p{
                    margin-bottom: 0;
                    &.subTitle-table{
                        margin-top: 3px;
                        color: #c5c2c2;
                    }
                }
            }
        }
    }
}

.circle{
    width: 30px;
    padding: 0px;
    width: 40px;
    background: var(--v-primary-base);
    ::v-deep path{
        fill: #ffffff !important;
    }
}
.subTitleCurso{
    font-size: 12px;
}
::v-deep .status-ok{
    path{
        fill: $green !important;
    }
}
::v-deep .status-nOk{
    path{
        fill: red !important;
    }
}

.rotation-180{
    transform: rotate(180deg);
}

.qtd-route{
    font-size: 14px;
    .current{
        font-size: 18px;
    }
}

.pendent{
    opacity: 0.3;
}
.cursor-pointer{
    cursor: pointer;
}
.button-delete{
    cursor: pointer;
    ::v-deep svg{
        g path{
            fill: red !important;
        }
    }
}

::v-deep svg.danger{
    path{
        fill: red !important;
    }
}

::v-deep svg.successIcon{
    path{
        fill: green !important;
    }
}



.btn-add{
    cursor: pointer;
    .circle{
        border-radius: 50%;
        background: var(--v-primary-base);
        width: 40px;

        ::v-deep path{
            fill: #ffffff !important;
        }
    }
    &:hover{
        .circle{
            background: var(--v-primary-lighten3);
        }
    }
}


.btn-action {
    background-color: white !important;
    border: 1px solid var(--v-primary-base);
    border-radius: 43px !important;
    transition: all .5s;
    ::v-deep svg{
        path{
            fill: var(--v-primary-base);
        }
    }
    &:hover{
        transition: all 1s;
        background-color: var(--v-primary-base) !important;
        .primary--text{
            color: #fff !important;
        }
        ::v-deep svg{
            path{
                fill: #fff;
            }
        }
    }
}
.btn-edit-route{
    display: flex;
    align-items: flex-end;
}

</style>
